










import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { BaseSelect } from '#components/baseSelect';

import { NAME } from '../constants';

type BaseMapperData = {
	NVSKLAD_ID: string;
	X_NVPRIJEMKA: string;
	KAROSERIE_NR_BEZ_M: string;
	KOMISE_NR: string,
	PNV_NR: number,
	PNV_ID: number,
	TYPKOD: string,
	X_TYPKOD: string,
	KAROSERIE_NR: string,
	PNV_VYRAZEN_PRP: boolean,
	PNV_ZAKAZNIK_ID: unknown,
	VYROBEKVOZ_OZN: string,
	X_VYROBEKVOZ_OZN: string,
};

type RequestedData = {
	value: string | null;
	text: string | null;
	komiseNr: string | null;
	// pnvNr: number | null;
	typkod: string | null;
	typkodText: string | null;
	karoserieNr: string | null;
	// pnvVyrazenPrp: boolean | null;
	// pnvZakaznikId: unknown | null;
	vyrobekVozOzn: string | null;
	vyrobekVozOznText: string | null;
};

type Data = {
	valueFieldName: string,
	storeObject: string;
	emptyObject: RequestedData,
};

export default BaseSelect.extend({
	name: 'OjeteVozidloSelect',
	props: {
		labelKey: { type: String, default: 'OVOZIDLO_ID' },
		labelKeyValue: { type: String, default: 'OVOZIDLO_ID' },
	},
	data(): Data {
		return {
			valueFieldName: 'OVOZIDLO_ID',
			storeObject: NAME,
			emptyObject: {
				value: null,
				text: null,
				komiseNr: null,
				typkod: null,
				typkodText: null,
				karoserieNr: null,
				vyrobekVozOzn: null,
				vyrobekVozOznText: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: BaseMapperData) {
			return {
				value: data.NVSKLAD_ID,
				text: `${data.X_NVPRIJEMKA} ${data.KAROSERIE_NR_BEZ_M}`,
				komiseNr: data.KOMISE_NR,
				typkod: data.TYPKOD,
				typkodText: data.X_TYPKOD,
				karoserieNr: data.KAROSERIE_NR,
				vyrobekVozOzn: data.VYROBEKVOZ_OZN,
				vyrobekVozOznText: data.X_VYROBEKVOZ_OZN,
			};
		},
		async openView() {
			await openEdit(NAME, PageMode.VIEW, { id: this.text as any });
		},
	},
});
